var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('h2', {
    staticClass: "mt-0"
  }, [_vm._v("We see colors differently")]), _vm._v(" "), _c('p', [_vm._v("\n      About 1 in 20 people are colorblind in some way. This means that one or more of the types of cone cells in their eyes — the cells we use to detect color — does not work normally. Because of this, a person who is colorblind sees a reduced color space; two colors which appear distinct to a person with normal color vision may appear to be the same to a person who is colorblind. This phenomenon is not random. Mathematically, there are lines through color space — called \"confusion lines\" — such that every color on a confusion line appears the same to a person who is colorblind as every other color on that same confusion line. \n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      This means that we can, to some degree, simulate colorblindness. By mathematically replicating the confusion line phenomenon, we can replace the colors in a picture so that if two of the original colors are on the same confusion line, they each get replaced by the same new color. If we do this the right way, a person with normal color vision can experience something like colorblindness. \n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Color Palette")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-center items-start pb-2"
  }, [_c('color-column', {
    attrs: {
      "label": "True",
      "colors": _vm.colors,
      "selectedIndex": _vm.selectedIndex,
      "trueColors": ""
    },
    on: {
      "select": function (index) { return _vm.selectColor(index); }
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Prot.",
      "colors": _vm.protanopiaColors
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Deut.",
      "colors": _vm.deuteranopiaColors
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Trit.",
      "colors": _vm.tritanopiaColors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-center items-stretch my-8"
  }, [_c('color-picker', {
    attrs: {
      "disableAlpha": true
    },
    model: {
      value: (_vm.selectedColor),
      callback: function($$v) {
        _vm.selectedColor = $$v
      },
      expression: "selectedColor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center justify-around w-16 ml-8"
  }, [_c('button', {
    staticClass: "flex justify-center items-center w-16 h-16 rounded-full border border-grey-darker text-grey-darker text-xl hover:shadow-md",
    attrs: {
      "aria-label": "Delete color.",
      "disabled": _vm.selectedIndex === -1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeColor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]), _vm._v(" "), _c('button', {
    staticClass: "w-16 h-16 rounded-full border border-solid border-grey-darker text-grey-darker text-xl flex justify-center items-center cursor-pointer hover:border-solid hover:font-bold hover:shadow-md",
    attrs: {
      "aria-label": "Add color."
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addColor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "flex justify-center items-center w-16 h-16 rounded-full border border-grey-darker text-grey-darker text-xl hover:shadow-md",
    attrs: {
      "aria-label": "Reset colors to defaults."
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetColors($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1), _vm._v(" "), _c('p', {
    staticClass: "bg-grey-light p-3"
  }, [_vm._v("\n      Click on one of the true colors to view or change it using the color picker. Click the "), _c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-label": "Icon for deletion."
    }
  }), _vm._v(" button to remove a selected color from the color palette. Click the "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-label": "Icon for new addition."
    }
  }), _vm._v(" button to add a new color to the color palette. Click the "), _c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-label": "Icon for resetting to default."
    }
  }), _vm._v(" button to reset all of the colors to my defaults. Your color palette is encoded in the URL for this page while you work, so you can save or share a color palette by saving the URL when you are finished. For example, here are links to "), _c('a', {
    attrs: {
      "href": "#%23648FFF-%23785EF0-%23DC267F-%23FE6100-%23FFB000"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pushColors(['#648FFF', '#785EF0', '#DC267F', '#FE6100', '#FFB000'])
      }
    }
  }, [_vm._v("the IBM design library \"color blind safe\" color palette")]), _vm._v(" and to "), _c('a', {
    attrs: {
      "href": "#%23000000-%23E69F00-%2356B4E9-%23009E73-%23F0E442-%230072B2-%23D55E00-%23CC79A7"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pushColors(['#000000', '#E69F00', '#56B4E9', '#009E73', '#F0E442', '#0072B2', '#D55E00', '#CC79A7'])
      }
    }
  }, [_vm._v("the \"colorblind barrier-free\" color palette")]), _vm._v(" from an "), _c('a', {
    attrs: {
      "href": "https://jfly.uni-koeln.de/color/",
      "rel": "external"
    }
  }, [_vm._v("Okabe and Ito 2002 article on J*FLY")]), _vm._v(".\n    ")]), _vm._v(" "), _c('h2', [_vm._v("There's more")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-center items-start pb-2 my-8"
  }, [_c('color-column', {
    attrs: {
      "label": "True",
      "colors": _vm.colors,
      "normal": ""
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Dtnm.",
      "colors": _vm.deuteranomalyColors
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n      The colorblindness simulations you see in the tool above are produced using state-of-the-art calculations. But while these calculations are widely used and broadly useful, the confusion lines used are imperfect and more study is required — especially regarding the rarer types of colorblindness — in order to say with certainty how exactly these simulations mirror the color vision of each person with colorblindness. \n    ")]), _vm._v(" "), _c('h2', [_vm._v("Red and green")]), _vm._v(" "), _c('p', [_vm._v("\n      The three types of cone cell in your eye are each responsible for detecting a different primary color: red, green, and blue. Because anomalies in these cells interfere with a person's ability to see these colors normally, it is a bad idea to use a color palette of red, green, and blue. In particular, you should avoid the common practice of using red and green as contrasting colors. See why for yourself. \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-center items-start pb-2 my-8"
  }, [_c('color-column', {
    attrs: {
      "label": "True",
      "colors": ['#f00', '#0f0'],
      "normal": ""
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Prot.",
      "colors": ['#8f7e1e', '#f8dc00']
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Deut.",
      "colors": ['#a17800', '#ffd599']
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-center items-start pb-2 my-8"
  }, [_c('color-column', {
    attrs: {
      "label": "True",
      "colors": ['#d81b60', '#0f0'],
      "normal": ""
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Prot.",
      "colors": ['#525975', '#f8dc00']
    }
  }), _vm._v(" "), _c('color-column', {
    attrs: {
      "label": "Deut.",
      "colors": ['#68564e', '#ffd599']
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n      Another common practice is to use red to highlight text. Again, this will not work well for some of your readers. People who are red-green colorblind will see a lower contrast between red text and the neutral colors which surround it. \n    ")]), _vm._v(" "), _c('h2', [_vm._v("Accessible palettes")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap justify-around items-center my-8"
  }, _vm._l((_vm.contrastingPairs), function(pair) {
    return _c('div', {
      staticClass: "flex justify-start items-center p-2 mb-4 w-64 shadow-md cursor-pointer hover:shadow-lg",
      staticStyle: {
        "border-top": "1px solid rgba(0,0,0,0.05)"
      },
      on: {
        "click": function($event) {
          _vm.pushColors(pair)
        }
      }
    }, [_c('div', {
      staticClass: "flex flex-col w-16 h-32"
    }, _vm._l((pair), function(color) {
      return _c('div', {
        key: color,
        staticClass: "w-16 h-16",
        style: ({
          'background': color
        })
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col h-32"
    }, _vm._l((pair), function(color) {
      return _c('div', {
        key: color,
        staticClass: "h-16 pl-2 flex flex-col justify-center items-start"
      }, [_c('span', [_c('b', [_vm._v("HEX")]), _vm._v(" " + _vm._s(color))]), _vm._v(" "), _c('span', [_c('b', [_vm._v("R")]), _vm._v(" " + _vm._s(parseInt(color.substring(1, 3), 16)) + " \n              "), _c('b', [_vm._v("G")]), _vm._v(" " + _vm._s(parseInt(color.substring(3, 5), 16)) + " \n              "), _c('b', [_vm._v("B")]), _vm._v(" " + _vm._s(parseInt(color.substring(5, 7), 16)) + "\n            ")])])
    }))])
  })), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center"
  }, _vm._l((_vm.palettes), function(palette) {
    return _c('div', {
      key: palette.name,
      staticClass: "p-2 my-4 shadow-md hover:shadow-lg cursor-pointer inline-block",
      staticStyle: {
        "border-top": "1px solid rgba(0,0,0,0.05)"
      },
      on: {
        "click": function($event) {
          _vm.pushColors(palette.colors)
        }
      }
    }, [_c('h3', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(palette.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-wrap justify-center"
    }, _vm._l((palette.colors), function(color) {
      return _c('div', {
        key: color,
        staticClass: "w-16 h-16",
        style: ({
          'background': color
        })
      })
    }))])
  })), _vm._v(" "), _c('h2', [_vm._v("Beyond colors")]), _vm._v(" "), _c('p', [_vm._v("\n      It is a good practice to, where possible, avoid conveying information purely through color. You should always consider adding other ways to convey the same information besides just color. For example, you might use text, symbols, or patterns. In a bar chart with bars of different colors, consider also giving the bars different patterns; perhaps bars of one color could also be dotted in black, while bars of another color could be overlaid with a crosshatch pattern. If you are using color to emphasize text, consider also using italics or boldface or some other form of emphasis as well. \n    ")])]), _vm._v(" "), _c('footer', {
    staticClass: "h-12 text-sm flex justify-center items-center"
  }, [_vm._v("\n    © David Nichols\n  ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "p-4 shadow-md border-t-4 border-black flex flex-wrap text-center justify-center sm:justify-between items-center text-center"
  }, [_c('h1', [_vm._v("Coloring for Colorblindness")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://davidnichols.ai",
      "target": "_blank"
    }
  }, [_vm._v("by David Nichols")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      This website is for people with normal or nearly normal color vision. The purpose of this website is to simulate for you what your chosen color palette looks like to viewers who are colorblind. The colors in the leftmost column are the \"true\" colors; these are displayed in the remaining three columns the way that a person with "), _c('b', [_vm._v("prot")]), _vm._v("anopia, "), _c('b', [_vm._v("deut")]), _vm._v("eranopia, or "), _c('b', [_vm._v("trit")]), _vm._v("anopia would see them, respectively. \n    ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      There are other types of colorblindness and color vision anomaly than the three types mentioned above. I recommend looking at "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Color_blindness#Types",
      "rel": "external"
    }
  }, [_vm._v("the Wikipedia entry on the subject")]), _vm._v(" for more information. The most common type of color vision anomaly is deuteranomaly, which involves reduced sensitivity — but not blindness — to the green region of the spectrum. Deuteranomaly affects 1 in every 16 or 17 men and 1 in every 250 women. You can see a simulation of deuteranomalous vision below. \n    ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Most people who are colorblind have some form of red-green colorblindness, such as deuteranomaly, deuteranopia, or protanopia. To a person with one of these forms of colorblindness, it can difficult or impossible to distinguish whether a given color is red or green, and shades of red and green may have very low contrast. Instead of using a color palette of red and green, consider using a similar "), _c('i', [_vm._v("magenta")]), _vm._v(" and green  color palette instead. \n    ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      So what colors "), _c('i', [_vm._v("should")]), _vm._v(" you use? The colorpicker tool above is intended to give the freedom to choose your own colors while making sure that your color palette is accessible. But to get you started, here are some ideas. Here are 8 pairs of contrasting colors which maintain their contrast for people who are colorblind. Click on any of them to load it into the color palette selection tool above. \n    ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      A number of color palettes have been developed with the intention of being accessible to people who are colorblind. Three of them appear below, from the "), _c('a', {
    attrs: {
      "href": "https://web.archive.org/web/20180503023309/https://www.ibm.com/design/language/resources/color-library",
      "rel": "external"
    }
  }, [_vm._v("IBM Design Library")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://jfly.uni-koeln.de/color/",
      "rel": "external"
    }
  }, [_vm._v("Okabe & Ito")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "https://sronpersonalpages.nl/~pault/",
      "rel": "external"
    }
  }, [_vm._v("Paul Tol")]), _vm._v(" respectively. Click on any of them to load it into the color palette selection tool above.\n    ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec5510c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Qj6K
// module chunks = 1